// focus modal cantine

import gsap from "gsap";

export function initFocusModal() {
    const modal = document.getElementById("focusCantine");
    if (!modal) return;

    const closeBtn = modal.querySelector(".close");
    const modalContent = modal.querySelector(".modal-cantine-content");
    const focusBtn = document.getElementById("focusBtn");

    // Funzione per mostrare il modal
    function showModal() {
        modal.classList.add("is-active");
        gsap.fromTo(
            modal,
            { opacity: 0, y: 50 },
            { opacity: 1, y: 0, duration: 0.5, ease: "power3.out" }
        );
    }

    // Funzione per nascondere il modal
    function hideModal() {
        gsap.to(modal, {
            opacity: 0,
            y: 50,
            duration: 0.3,
            ease: "power3.in",
            onComplete: () => {
                modal.classList.remove("is-active");
            }
        });
    }

    // Mostra il modal al click del bottone focusBtn
    if (focusBtn) {
        focusBtn.addEventListener("click", (e) => {
            e.preventDefault();
            showModal();
        });
    }

    // Chiudi il modal cliccando sullo sfondo
    modal.addEventListener("click", (e) => {
        if (e.target === modal) hideModal();
    });

    // Chiudi il modal cliccando sulla X
    if (closeBtn) {
        closeBtn.addEventListener("click", (e) => {
            e.preventDefault();
            hideModal();
        });
    }

    // Previeni la chiusura cliccando sui contenuti interni
    if (modalContent) {
        modalContent.addEventListener("click", (e) => {
            e.stopPropagation();
        });
    }
}